export const StatusBadge = ({ status }) => {
  const ok = status === "Direkomendasikan";
  return (
    <span
      data-testid="recap-status-badge"
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold border ${
        ok
          ? "bg-emerald-50 text-emerald-700 border-emerald-200"
          : "bg-rose-50 text-rose-700 border-rose-200"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${ok ? "bg-emerald-500" : "bg-rose-500"}`} />
      {status}
    </span>
  );
};

export const scoreColor = (s) => {
  if (s >= 8.5) return "text-emerald-600";
  if (s >= 7) return "text-blue-600";
  if (s >= 5) return "text-amber-600";
  return "text-rose-600";
};
